/*
 * 埋点
*/

const state = {
  // trackConfig: [{
  //   'event': 'login', // 登录
  //   'event_type': 'click', // 事件类型
  //   'path': '/login', // 页面路径
  //   'element_pos': '.el-button.el-button--primary', // 触发元素： #id .div.p
  //   'method': 'handleLogin',
  //   'content': 'loginForm'
  // }],
  // 埋点配置
  trackConfig: {
    '/login': [{
      'event': 'admin_login', // 登录
      'event_type': 'click', // 事件类型
      'element_pos': '.el-button.el-button--primary', // 触发元素： #id .div.p
      'method': 'handleLogin',
      'content': 'loginForm'
    }],
    '/doctor/list': [{
      'event': 'doctor_search', // 医生列表查询
      'event_type': 'click', // 事件类型
      'element_pos': '.el-button.el-button--primary', // 触发元素： #id .div.p
      'method': 'search',
      'content': 'searchInfo,statusText'
    }, {
      'event': 'doctor_export_all', // 医生全部导出
      'event_type': 'click', // 事件类型
      'element_pos': '.el-dropdown-menu__item', // 触发元素： #id .div.p
      'method': 'exportDoctor?1'
    }, {
      'event': 'doctor_export', // 医生指定导出
      'event_type': 'click', // 事件类型
      'element_pos': '.el-dropdown-menu__item', // 触发元素： #id .div.p
      'method': 'exportDoctor?0',
      'content': 'searchInfo,statusText'
    }, {
      'event': 'doctor_detail', // 医生查看
      'event_type': 'click', // 事件类型
      'element_pos': '.el-button--text', // 触发元素： #id .div.p
      'method': 'doctorDetail?,detail',
      'content': 'doctorCode=$0,statusText'
    }, {
      'event': 'doctor_mark_test', // 标记测试
      'event_type': 'click', // 事件类型
      'element_pos': '.el-button--text', // 触发元素： #id .div.p
      'method': 'markSure?,1,1',
      'content': 'doctorCode=$0,statusText'
    }, {
      'event': 'doctor_mark_formal', // 标记正式
      'event_type': 'click', // 事件类型
      'element_pos': '.el-button--text', // 触发元素： #id .div.p
      'method': 'markSure?,1,0',
      'content': 'doctorCode=$0,statusText'
    }],
    '/doctor/edit': [{
      'event': 'doctor_edit', // 医生编辑
      'event_type': 'click', // 事件类型
      'element_pos': '.el-button.el-button--primary', // 触发元素： #id .div.p
      'method': 'updateDoctorInfo',
      'content': 'doctorCode,authStatus'
    }],
    '/doctor/audit': [{
      'event': 'doctor_audit', // 医生编辑
      'event_type': 'click', // 事件类型
      'element_pos': '.el-button.el-button--primary', // 触发元素： #id .div.p
      'method': 'audit',
      'content': 'doctorCode,auditStatus=$0'
    }]
  },
  // 已经埋点过了
  hasTracked: [],
  // env数据
  device: ''
}

const mutations = {
  // 获取设备信息
  UPDATE_DEVICE(state, device) {
    state.device = device
  },
  // 记录埋点页面
  ADD_TRACKED_PAGE(state, page) {
    state.hasTracked.push(page)
  }
}

const actions = {
  updateDevice({ commit }, device) {
    commit('UPDATE_DEVICE', device)
  },
  addTrackedPage({ commit }, page) {
    commit('ADD_TRACKED_PAGE', page)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
